<template>
    <div class="">
      <Card class="">
        <template #title> Öğünler </template>
        <template #content>
          <div class="mt-1 mb-2 mr-3">
            <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniOgun()" />
          </div>
          <DataTable v-if="DataTable_render" :columns="columns" :data="OgunListesi" v-on:set-child-data="getDataChild"
            :editbutton="true" />
        </template>
      </Card>
    </div>
  </template>
  
  <script>
  import DataTable from "../../DataTable/BasicDataTable.vue";
  import GlobalServis from "../../../../../services/GlobalServis";
  import { required, helpers } from "@vuelidate/validators";
  import { useVuelidate } from "@vuelidate/core";
  
  export default {
    setup: () => ({ v$: useVuelidate() }),
    data() {
      return {
        DataTable_render: true,
        OgunListesi: [],
        columns: [
          { field: "Ad", header: "Öğün Adı" },
          { field: "Aciklama",  header: "Açıklama" },
        ],
  
        OgunAd: null,
        OgunAciklama: null,
        Ogun_rowid: null,
      };
    },
    methods: {
      getDataChild(getdata_child) {
        this.Ogun_rowid = getdata_child.data.Ogun_rowid;      
        this.$router.push({ path: "/Diyetisyen/DuzenleOgun", query: { OgunNo: this.Ogun_rowid } });
      },
      _YeniOgun() {
        this.$router.push({ path: "/Diyetisyen/YeniOgun" });
      },
      InitServis() {
        GlobalServis.GlobalServis("GET", "GetOgunTablosu", "").then((res) => {
          if (res.status == 200) {
            this.OgunListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        });
      },
    },
    mounted() {
      this.InitServis();
    },
    components: {
      DataTable,
    },
    validations() {
      return {
        OgunAd: {
          required: helpers.withMessage("Bu alan boş bırakılamaz", required),
        },
        OgunAciklama: {
          required: helpers.withMessage("Bu alan boş bırakılamaz", required),
        },
      };
    },
  };
  </script>